export const data = [ 
    {
        id: 1,
        title : "Mahmoud is work as a Full Stack Web Developer exceeded our expectations. His proficiency in coding and problem-solving was evident in every task he undertook. Mahmoud is dedication to delivering high-quality solutions in a timely manner is commendable. We are grateful for his expertise and recommend him without hesitation."
    },
    {
        id: 2,
        title : "Working with Mahmoud as our Full Stack Web Developer was a game-changer. His proficiency in both front-end and back-end development brought our project to a whole new level. Mahmoud is ability to turn ideas into advanced digital solutions is truly remarkable. We highly recommend his services."
    },
    {
        id: 3,
        title : "Mahmoud is an exceptional Full Stack Web Developer. His technical skills and attention to detail were evident throughout our collaboration. He tackled complex challenges with ease and consistently delivered high-quality work. It was a pleasure working with him, and we look forward to future projects together."
    },
]